import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';

import { apiClient } from 'api/apiClient';
import type { ICreatePasswordData } from 'api/types/password';
import type { IRequestException } from 'api/types/requestException';

const changePassword = async ({
    emailToken,
    password,
}: ICreatePasswordData) => {
    return await apiClient.post('users/change-password', {
        json: {
            emailToken,
            password,
        },
    });
};

export const useChangePasswordMutation = (
    options: UseMutationOptions<
        Response,
        IRequestException,
        ICreatePasswordData
    >
) => {
    return useMutation(async (props) => await changePassword(props), options);
};
